import { http } from '../helpers/http'
import { buildFindAllUrl } from './shared.service'

const exportInformation = (eventId, informationId, mapUrl, format) => {
  return http.post(`/event/${eventId}/information/${informationId}/export`,
    {
      printUrl: mapUrl,
      format: format
    },
    {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf'
      }
    })
}

const find = ({ eventId, informationId }) => {
  return http.get(`/event/${eventId}/information/${informationId}`)
}

const findAll = filters => {
  let url = '/informations'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

const findEventInformations = ({ eventId, filters, ...params }) => {
  params.filters = JSON.stringify(filters)
  return http.get(`/event/${eventId}/informations`, { params })
}

const deleteInformation = (eventId, informationId) => {
  return http.delete(`/event/${eventId}/information/${informationId}`)
}

const create = information => {
  const cleanInformation = {
    informationNature: information.informationNature.id || null,
    recipient: (information.recipient !== null && information.recipient.id !== 'other' ? information.recipient.id : null) || null,
    origin: (information.origin !== null && information.origin.id !== 'other' ? information.origin.id : null) || null,
    label: information.label,
    startingDate: information.startingDate || null,
    endingDate: information.endingDate || null,
    coordinates: information.coordinates || null,
    otherOrigin: information.otherOrigin || null,
    otherRecipient: information.otherRecipient || null,
    description: information.description || null,
    moreInformation: information.moreInformation || null
  }
  return http.post(`/event/${information.event.id}/informations`, cleanInformation)
}

const update = (id, information) => {
  const cleanInformation = {
    informationNature: information.informationNature.id || null,
    recipient: (information.recipient.id !== 'other' ? information.recipient.id : null) || null,
    origin: (information.origin.id !== 'other' ? information.origin.id : null) || null,
    label: information.label,
    startingDate: information.startingDate || null,
    endingDate: information.endingDate || null,
    coordinates: information.coordinates || null,
    otherOrigin: information.otherOrigin || null,
    otherRecipient: information.otherRecipient || null,
    description: information.description || null,
    moreInformation: information.moreInformation || null
  }
  return http.patch(`/event/${information.event.id}/information/${id}`, cleanInformation)
}

const removeFile = (eventId, informationId, fileId) => {
  return http.delete(`event/${eventId}/information/${informationId}/attachment/${fileId}`)
}

const findHistory = (eventId, informationId) => {
  return http.get(`/event/${eventId}/information/${informationId}/history`)
}

export const informationService = {
  find,
  findAll,
  findEventInformations,
  create,
  update,
  deleteInformation,
  removeFile,
  findHistory,
  exportInformation
}
